import Main from '@/views/administracion/ejecucion/Main.vue';
import Default from '@/views/administracion/ejecucion/Default.vue';
import MainContrato from '@/views/administracion/ejecucion/contrato/Main.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import DefaultContratoEjecucion from '@/views/administracion/contratos/contrato/Default.vue';
import MainContratoReporteFisico from '@/views/administracion/ejecucion/contrato/reportes/Main.vue';
import MainEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/Default.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainGraficaComparativaAvances from '@/views/administracion/ejecucion/contrato/graficacomparativaavances/Main.vue';
import MainActividades from '@/views/administracion/ejecucion/contrato/actividades/Main.vue';
import MainExpediente from '@/views/administracion/ejecucion/contrato/expediente/Main.vue';
import MainAlbum from '@/views/administracion/ejecucion/contrato/album/Main.vue';
import MainEstadisticas from '@/views/administracion/ejecucion/estadisticas/Main.vue';
import MainContratoFechas from '@/views/administracion/ejecucion/contrato/fechas/Main.vue';
import MainContratoGarantias from '@/views/administracion/ejecucion/contrato/garantias/Main.vue';
import MainContratoVideos from '@/views/administracion/contratos/contrato/contratovideos/Main.vue';
import MainContratoObservaciones from '@/views/administracion/ejecucion/contrato/observaciones/Main.vue';
import MainContratoArchivos from '@/views/contratistas/contratos/contrato/archivoscontratista/Main.vue';
import MainContratoDiarioActividades from '@/views/contratistas/contratos/contrato/diario-actividades/Main.vue';
import Configuracion from './configuracion';

const auth = ['Supervisión:ver'];
const scopes = ['Supervisión:crear', 'Supervisión:editar', 'Supervisión:eliminar'];

const ejecucion = [
  {
    path: 'ejecucion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'contratoEjecucionEstadisticas',
        path: 'estadisticas',
        meta: {
          title: 'Ejecucion Estadisticas',
          auth,
          scopes,
        },
        component: MainEstadisticas,

        children: [],
      },
      ...Configuracion,
      {
        name: 'ejecucion',
        path: '/',
        meta: {
          title: 'Ejecución',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':idContrato',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainContrato,
        children: [
          {
            name: 'contratoEjecucionGenerales',
            path: '/',
            meta: {
              title: 'Generales',
              auth,
              scopes,
            },
            component: DefaultContratoEjecucion,
          },
          {
            name: 'contratoEjecucionReportes',
            path: 'reportes',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: MainContratoReporteFisico,
          },
          {
            name: 'contratoAlbum',
            path: 'album',
            meta: {
              title: 'Album Fotográfico',
              auth,
              scopes,
            },
            component: MainAlbum,
          },
          {
            name: 'contratoVideos',
            path: 'videos',
            meta: {
              title: 'Videos',
              auth,
              scopes,
            },
            component: MainContratoVideos,
          },
          {
            name: 'contratoEjecucionAnticipos',
            path: 'anticipos',
            meta: {
              title: 'Anticipos',
              auth,
              scopes,
            },
            props: {
              soloLectura: true,
            },
            component: MainAnticipos,
          },
          {
            name: 'contratoEjecucionCatalogo',
            path: 'catalogo',
            meta: {
              title: 'Catálogo',
              auth,
              scopes,
            },
            props: {
              soloLectura: true,
            },
            component: MainCatalogo,
          },
          {
            name: 'contratoEjecucionPrograma',
            path: 'programa',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: MainPrograma,
            props: {
              soloLectura: true,
            },
          },
          {
            name: 'contratoEjecucionEstimaciones',
            path: 'estimaciones',
            meta: {
              title: 'Contrato',
              auth,
              scopes,
            },
            component: MainEstimaciones,
            props: {
              soloLectura: true,
            },
          },
          {
            path: 'grafica-comparativa',
            name: 'contratoGraficaComparativaAvances',
            meta: {
              title: 'Gráfica Comparativa',
              auth,
              scopes,
            },
            component: MainGraficaComparativaAvances,
          },
          {
            path: 'actividades',
            name: 'contratoEjecucionActividades',
            meta: {
              title: 'Actividades',
              auth,
              scopes,
            },
            component: MainActividades,
          },
          {
            name: 'contratoEjecucionExpediente',
            path: 'expediente',
            meta: {
              title: 'Expediente',
              auth,
              scopes,
            },
            component: MainExpediente,
          },
          {
            name: 'contratoFechas',
            path: 'fechas',
            meta: {
              title: 'Contratos fechas',
              auth,
              scopes,
            },
            component: MainContratoFechas,
          },
          {
            name: 'contratoGarantias',
            path: 'garantias',
            meta: {
              title: 'Garantías',
              auth,
              scopes,
            },
            component: MainContratoGarantias,
          },
          {
            name: 'contratoObservaciones',
            path: 'observaciones',
            meta: {
              title: 'Observaciones',
              auth,
              scopes,
            },
            component: MainContratoObservaciones,
          },
          {
            name: 'contratoEjecucionArchivosContratista',
            path: 'archivoscontratista',
            meta: {
              title: 'Archivos Contratista',
              auth,
              scopes,
            },
            props: {
              soloLectura: true,
            },
            component: MainContratoArchivos,
          },
          {
            name: 'contratoEjecucionDiarioActividades',
            path: 'diario-actividades',
            meta: {
              title: 'Diario de Actividades',
              auth,
              scopes,
            },
            props: {
              soloLectura: true,
            },
            component: MainContratoDiarioActividades,
          },
        ],
      },
    ],
  },
];

export default ejecucion;
